<template>
  <div class="loginMobile">
      <mask-evaluation></mask-evaluation>
      <im-top></im-top>
      <div class="wrapText">手机号为查看单据处理结果的依据</div>
      <div class="content">
          <span class="text">手机号</span>
          <div class="inputContent">
              <el-input v-model="phoneNum" placeholder="请输入手机号码"></el-input>
          </div>
      </div>
      <div class="errText">请检查填写的手机号是否正确</div>
      <div class="content" style="margin-top:13px">
          <span class="text">随机码</span>
          <div class="inputContent">
              <el-input v-model="input" placeholder="短信随机码"><template slot="append"><a href="javascript:;">获取短信随机码</a></template></el-input>
          </div>
      </div>
      <a class="nextStep" href="javascript:;">下一步</a>
  </div>
</template>
<script>
import imTop from '../im/IMTop.vue'
import maskEvaluation from '../maskEvaluation/maskEvaluation'

export default {
  components:{
    imTop,
    maskEvaluation
  },
  name: 'LoginMobile',
  data () {
    return {
      

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loginMobile .wrapText {
    font-size: 14px;color: #999;
    width: 260px;
    margin:  120px auto 8px;
}
.loginMobile .errText {
    font-size: 12px;color: #999;
    width: 260px;
    margin: 0  auto 8px;
    color: #ed6b75;
}
.loginMobile .content {
    
    width: 370px;
    margin: 0 auto;
}
.loginMobile .content .text{
    margin-right: 10px;
    font-size: 14px;
    color: #666;
}
.loginMobile .content .inputContent {
    display: inline-block;
    width: 300px;
    height: 40px;
}
.loginMobile .content .inputContent a{
    width: 120px;
    display: inline-block;
    background: #36c6d3;
    color: #ffffff;
}
.loginMobile .nextStep{
    display: block;
    width: 90px;
    height: 40px;
    background: #009688;
    color: #f4f9f8;
    border-radius: 6px;
    margin: 40px auto  0;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/im/loginMobile.vue?d1d7a7c6